import clsx from "clsx";
import React from "react";

export default function Heading(props) {
   // Propriétés des Titles
   const { children, variant, theme, display, position, className } = props;

   const defaultClass = "uppercase ";
   let font, color, align;

   switch (theme) {
      case "secondary":
         font = "font-secondary font-semibold tracking-tighter";
         break;

      case "title":
         font = "font-title tracking-tighter ";
         break;

      default:
         break;
   }

   switch (display) {
      case "gray":
         color = "text-gray-600";
         break;

      default:
         color = "text-secondary";
         break;
   }

   switch (position) {
      case "center":
         align = "justify-center";
         break;
      case "center":
         align = "justify-end";
         break;

      default:
         align = "justify-start";
         break;
   }

   switch (variant) {
      case "h3":
         return (
            <div className={clsx(`flex ${align}`, className)}>
               <h3 className={`${defaultClass} text-2xl md:text-3xl ${font} ${color}`}>
                  {children}
               </h3>
            </div>
         );
      case "h4":
         return (
            <div className={clsx(`flex ${align}`, className)}>
               <h4 className={`${defaultClass} text-2xl ${font} ${color}`}>
                  {children}
               </h4>
            </div>
         );
      default:
         return (
            <div className={clsx(`flex ${align}`, className)}>
               <h2
                  className={`${
                     theme === "title" ? "text-2xl md:text-5xl" : "text-xl md:text-3xl"
                  } ${defaultClass} ${font} ${color} `}
               >
                  {children}
               </h2>
            </div>
         );
   }
}
